import * as moment from 'moment';

export function getDateToFrontend(value: string): Date {
  return moment(
    moment(value).utcOffset(0).format('YYYY-MM-DD HH:mm'),
    'YYYY-MM-DD HH:mm',
    true
  ).toDate();
}

export function getDateToBackend(value: string | Date): string {
  return moment(value).utc(true).toISOString();
}
